export default "__VITE_ASSET__C0L1QDj3__"